<div class="row">
  <div class="col-12">
    <div id="google-pay-container" [hidden]="true"></div>
    <div id="applePayDiv" [hidden]="true"></div>
  </div>

  <div class="col-12" *ngIf="!googlePayDisponivel && !applePayDisponivel && !msgErro">
    <div class="alert alert-info mt-2 mb-2">
      Carregando carteiras digitais...
    </div>
  </div>

  <ng-container *ngIf="layoutLinkPedido; else layoutPadraoCarteirasDigitais">
    <div   *ngIf="googlePayDisponivel" class="d-block w-100">
      <button class="opcao-carteira-link destaque" type="button"
              [disabled]="processando"
              (click)="escolheuPagamentoGoogle()">
        <img src="/images/google-pay-logo.svg" alt="Google Pay" class="google-pay-logo">
        <span class="conteudo-opcao-carteira">
          <strong>Google Pay</strong>
          <small>Pagamento rápido e seguro</small>
        </span>
        <span class="selo-rapido">
          <i class="fe-zap"></i>
          Rápido
        </span>
        <i class="fe-chevron-right seta-opcao"></i>
      </button>

      <div class="pagamento-digital-status mt-2" *ngIf="processando && carteiraDigitalProcessando === 'GooglePay'">
        <div class="loading-circle"></div>
        <div class="mensagem-pagamento-digital">
          <strong>Aguardando confirmação do Google Pay</strong>
          <span>Finalize o pagamento no seu dispositivo para continuar.</span>
        </div>
        <button class="btn btn-outline-primary btn-sm" type="button" (click)="cancelePagamentoDigital()">
          Cancelar pagamento
        </button>
      </div>
    </div>

    <div class="col-12" *ngIf="applePayDisponivel">
      <button class="opcao-carteira-link destaque" type="button"
              [disabled]="processando"
              (click)="escolheuPagamentoApplePay()">
        <i class="fab fa-apple-pay logo-apple-link"></i>
        <span class="conteudo-opcao-carteira">
          <strong>Apple Pay</strong>
          <small>Pagamento rápido e seguro</small>
        </span>
        <span class="selo-rapido">
          <i class="fe-zap"></i>
          Rápido
        </span>
        <i class="fe-chevron-right seta-opcao"></i>
      </button>

      <div class="pagamento-digital-status mt-2" *ngIf="processando && carteiraDigitalProcessando === 'ApplePay'">
        <div class="loading-circle"></div>
        <div class="mensagem-pagamento-digital">
          <strong>Aguardando confirmação do Apple Pay</strong>
          <span>Finalize o pagamento no seu dispositivo para continuar.</span>
        </div>
        <button class="btn btn-outline-primary btn-sm" type="button" (click)="cancelePagamentoDigital()">
          Cancelar pagamento
        </button>
      </div>
    </div>
  </ng-container>

  <ng-template #layoutPadraoCarteirasDigitais>
    <div class="form-group col-12 cartao-online mb-0" *ngIf="googlePayDisponivel">
    <div class="mt-1">
      <span class="radio radio-blue w-100" [ngClass]="{'selecionado': pedido.pagamento?.formaDePagamento?.id === formaDePagamento.id &&
        pedido.pagamento?.carteiraDigital === 'GooglePay'}">
        <input id="formaPagamentoGooglePay"
               name="formaDePagamento"
               type="radio"
               [(ngModel)]="pedido.pagamento.formaDePagamento"
               [value]="formaPagamentoGooglePay"
               class="k-radio"
               kendoRadioButton
               [disabled]="processando"
               (click)="escolheuPagamentoGoogle()" />

        <img src="/images/google-pay-logo.svg" alt="Google Pay" class="google-pay-logo ml-1">

        <label for="formaPagamentoGooglePay" class="ml-0 d-inline">
          Google Pay
          <span class="text-muted font-11 ml-1 d-inline"
                *ngIf="formaDePagamento.taxaCobranca && formaDePagamento.taxaCobranca.ativa">
            (+{{formaDePagamento.taxaCobranca.percentual}}% taxa)
          </span>
        </label>
      </span>

      <div class="pagamento-digital-status mt-2" *ngIf="processando && carteiraDigitalProcessando === 'GooglePay'">
        <div class="loading-circle"></div>
        <div class="mensagem-pagamento-digital">
          <strong>Aguardando confirmação do Google Pay</strong>
          <span>Finalize o pagamento no seu dispositivo para continuar.</span>
        </div>
        <button class="btn btn-outline-primary btn-sm" type="button" (click)="cancelePagamentoDigital()">
          Cancelar pagamento
        </button>
      </div>
    </div>
  </div>

    <div class="form-group col-12 cartao-online mb-0" *ngIf="applePayDisponivel">
    <div class="mt-1">
      <span class="radio radio-blue w-100" [ngClass]="{'selecionado': pedido.pagamento?.formaDePagamento?.id === formaDePagamento.id &&
        pedido.pagamento?.carteiraDigital === 'ApplePay'}">
        <input id="formaPagamentoApplePay"
               name="formaDePagamento"
               type="radio"
               [(ngModel)]="pedido.pagamento.formaDePagamento"
               [value]="formaPagamentoApplePay"
               class="k-radio"
               kendoRadioButton
               [disabled]="processando"
               (click)="escolheuPagamentoApplePay()" />
        <i class="fab fa-apple-pay fa-2x ml-2 mr-2"></i>
        <label for="formaPagamentoApplePay" class="ml-0 d-inline">
          Apple Pay
          <span class="text-muted font-11 ml-1 d-inline"
                *ngIf="formaDePagamento.taxaCobranca && formaDePagamento.taxaCobranca.ativa">
            (+{{formaDePagamento.taxaCobranca.percentual}}% taxa)
          </span>
        </label>
      </span>

      <div class="pagamento-digital-status mt-2" *ngIf="processando && carteiraDigitalProcessando === 'ApplePay'">
        <div class="loading-circle"></div>
        <div class="mensagem-pagamento-digital">
          <strong>Aguardando confirmação do Apple Pay</strong>
          <span>Finalize o pagamento no seu dispositivo para continuar.</span>
        </div>
        <button class="btn btn-outline-primary btn-sm" type="button" (click)="cancelePagamentoDigital()">
          Cancelar pagamento
        </button>
      </div>
    </div>
  </div>
  </ng-template>

  <div class="col-12" *ngIf="msgErro">
    <div class="alert alert-danger mt-2">
      {{msgErro}}
    </div>
  </div>


</div>


